let initialState = {
    user: null,
};

export default function appReducer(state = initialState, action) {
    switch (action.type) {
        case "USER_DATA":
            return Object.assign({}, state, { user: action.payload });
        default:
            return state;
    }
}
